import { create } from 'zustand'
import { produce } from 'immer'
import { type StrategyTrade } from '../../models/trade/strategy-trade'

interface TradeStoreState {
  trades: Record<string, StrategyTrade[]>
  addTrade: (url: string, trades: StrategyTrade) => void
  addTrades: (url: string, trades: StrategyTrade[]) => void
  clearStore: (url: string) => void
}

export const useTradeStore = create<TradeStoreState>((set) => ({
  trades: {},
  addTrade: (url, trade) => {
    set(
      produce((state) => {
        if (state.trades[url] == null) {
          state.trades[url] = []
        }
        state.trades[url].unshift(trade)
      })
    )
  },
  addTrades: (url, trades) => {
    set(
      produce((state) => {
        if (state.trades[url] == null) {
          state.trades[url] = []
        }
        state.trades[url].unshift(...trades)
      })
    )
  },
  clearStore: (url) => {
    set(
      produce((state) => {
        state.trades[url] = null
      })
    )
  }
}))
